import { init } from './init';
import { get } from './get';
import { add, addDeep } from './set';
import { delGroup, clear } from './delete';

export default {
    init,
    get,
    delGroup,
    clear,
    add,
    addDeep
};
